"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteMarketsRecord = void 0;
var immutable_1 = require("immutable");
var core_1 = require("@gin-betting/core");
var gambler_settings_1 = __importDefault(require("@gin-betting/gambler-settings"));
var constants_1 = require("./constants");
var _a = gambler_settings_1.default.constants, GET_GAMBLER_SETTINGS_REQUEST = _a.GET_GAMBLER_SETTINGS_REQUEST, GET_GAMBLER_SETTINGS_FAIL = _a.GET_GAMBLER_SETTINGS_FAIL, GET_GAMBLER_SETTINGS_SUCCESS = _a.GET_GAMBLER_SETTINGS_SUCCESS;
exports.FavoriteMarketsRecord = immutable_1.Record({
    favoriteMarketsId: {},
    fetchStatus: core_1.App.FetchStatus.INITIAL,
}, 'FavoriteMarketState');
var initialState = new exports.FavoriteMarketsRecord();
var makeFavoriteMarketsReducer = function () { return function (state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_GAMBLER_SETTINGS_REQUEST:
        case constants_1.ADD_FAVORITE_MARKET_REQUEST: {
            return state.set('fetchStatus', core_1.App.FetchStatus.LOADING);
        }
        case GET_GAMBLER_SETTINGS_SUCCESS:
        case constants_1.ADD_FAVORITE_MARKET_SUCCESS: {
            var settings = action.payload.data.gambler.settings;
            var favoriteSetting = settings &&
                settings.find(function (setting) { return setting.name === constants_1.FAVORITE_MARKETS_KEY; });
            var filteredSettings = (_a = favoriteSetting === null || favoriteSetting === void 0 ? void 0 : favoriteSetting.value) !== null && _a !== void 0 ? _a : '';
            var favoriteMarketsId = filteredSettings.length
                ? JSON.parse(filteredSettings)
                : {};
            return state
                .set('fetchStatus', core_1.App.FetchStatus.LOADED)
                .set('favoriteMarketsId', favoriteMarketsId);
        }
        case GET_GAMBLER_SETTINGS_FAIL:
        case constants_1.ADD_FAVORITE_MARKET_FAIL: {
            return state.set('fetchStatus', core_1.App.FetchStatus.FAILED);
        }
        default: {
            return state;
        }
    }
}; };
exports.default = makeFavoriteMarketsReducer;
//# sourceMappingURL=reducer.js.map